import axios from 'axios'

const endpoints = {
  getPricing: 'pricing/featured/'
}

function getFeaturedProducts (baseUrl, dealerId, num) {
  var url = baseUrl + endpoints.getPricing + `?dealerId=${dealerId}&n=${num}`
  return axios.get(url)
}

export {
  getFeaturedProducts
}
